export default __webpack_public_path__ + "static/media/hamburger.79c85f28.svg";